//(function () {
    //'use strict';
angular
    .module('app')
    .directive("errorComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcErrors);
    }])
    .directive("usersComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminUsers);
    }])
    .directive("rolesComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminRoles);
    }])
    .directive("roleEditComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminRoleEdit);
    }])
    .directive("userAccessComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminUserAccess);
    }])
    .directive("quarterlyForecastSettingsComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcQuarterlyForecastSettings);
    }])
    .directive("userEditComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminUserEdit);
    }])
    .directive("forecastingPatternComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminForecastingPattern);
    }])
    .directive("htsFlashEditComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminHTSFlashEdit);
    }])
    .directive("forecastingColorwayComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminForecastingColorway);
    }])
    .directive("toolsCalculatorMarginComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcToolsCalculatorMarginComponent);
    }])
    .directive("libraryEntryComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcToolsLibraryEntry);
    }])
    .directive("toolsCalculatorFobComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcToolsCalculatorFOBComponent);
    }])
    .directive("flashEditCostingComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminFlashEditCostingComponent);
    }])
    .directive("lpcCorporateTemplateViewComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminLPCTemplateViewComponent);
    }])
    .directive("lpcCorporateTemplateEditComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminLPCTemplateEditComponent);
    }])
    .directive("systemMessagesListComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminSystemMessagesListComponent);
    }])
    .directive("systemMessagesEditComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminSystemMessagesEditComponent);
    }])
    .directive("helpComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcHelpComponent);
    }])
    .directive("buyReadyReportComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminBuyReadyReportComponent);
    }])
    .directive("uploadQueueComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminUploadQueueComponent);
    }])
    .directive("quarterlySalesForecastingComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminQuarterlySalesForecastingComponent);
    }])
    .directive("profileComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcProfileComponent);
    }])
    .directive("criticalPathIndexComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminCriticalPathIndexComponent);
    }])
    .directive("linePlanCreateComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminLinePlanCreateComponent);
    }])
    .directive("briefCreateComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminBriefCreateComponent);
    }])
    .directive("linePlanEditComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminLinePlanEditComponent);
    }])
    .directive("patternCreateComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminPatternCreateComponent);
    }])
    .directive("prototypeCreateComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminPrototypeCreateComponent);
    }])
    .directive("projectCreateComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminProjectCreateComponent);
    }])
    .directive("criticalPathDevPrototypeEditComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminCriticalPathDevPrototypeEditComponent);
    }])
    .directive("criticalPathDevPatternEditComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminCriticalPathDevPatternEditComponent);
    }])
    .directive("criticalPathCommercializationEditComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminCriticalPathCommercializationEditComponent);
    }])
    .directive("carryOverComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminCarryOverComponent);
    }])
    .directive("carryOverFinalComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminCarryOverFinalComponent);
    }])
    .directive("carryOverSelectComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminCarryOverSelectComponent);
    }])

    .directive("briefEditComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminBriefEditComponent);
    }])
    .directive("patternEditComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminPatternEditComponent);
    }])
    .directive("colorwayEditComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminColorwayEditComponent);
    }])
    .directive("searchComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminSearchComponent);
    }])
    .directive("loginComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminLoginComponent);
    }])
    .directive("forgotPasswordComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminForgotPasswordComponent);
    }])
    .directive("forgotPasswordMessageComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminForgotPasswordMessageComponent);
    }])
    .directive("transferChecklistComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminTransferChecklistComponent);
    }])
    .directive("homeComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminHomeComponent);
    }])
    .directive("displayMessageComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminDisplayMessageComponent);
    }])
    .directive("headerNavComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminHeaderNavComponent);
    }])
    .directive("displayUserMessageComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminDisplayUserMessageComponent);
    }])
    .directive("migrationsComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminMigrationsComponent);
    }])
    .directive("quickSearchComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminQuickSearchComponent);
    }])
    .directive("changePasswordComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminChangePasswordComponent);
    }])
    .directive("systemAlertComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminSystemAlertComponent);
    }])
    .directive("versionAlertComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcVersionAlertComponent);
    }])
    .directive("versionComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcVersionComponent);
    }])
    .directive("goBackComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcGoBackComponent);
    }])
    .directive("systemMessagesComponent", ['createVueComponent', function (createVueComponent) {
        return createVueComponent(window.vcAdminSystemMessages);
    }])
    ;
    

